import getAttributesImport from '../../settings/attributes'
import { launcherOpenUrl } from '../../launcherBackend/launcher-command'
import { actionLoggerLog } from '../../actions'
import { LOCALE_CHANGED } from '../../constants'
import { selectors as backendSelectors } from '../Backend'
import { selectors as steamSelectors } from '../Steam'

export { default as getTexts } from '../../store/localizer'

export const getAttributes = (locale) => {
    const attributes = getAttributesImport(locale)
    return { patchNotes: attributes.link.patchNotes }
}

export const commands = {
    launcherOpenUrl,
}

export const actions = {
    log: actionLoggerLog,
}

export const constants = {
    LOCALE_CHANGED,
}

export const selectors = {
    getLauncherBackendVersion: state => backendSelectors.getLauncherBackendVersion(state),
    getActiveEveClientVersion: state => backendSelectors.getActiveEveClientVersion(state),
    getProgress: state => backendSelectors.getActiveProgress(state),
    getActiveServerId: state => backendSelectors.getActiveServerId(state),
    getActiveServerName: state => backendSelectors.getActiveServerName(state),
    getLocale: state => backendSelectors.getLocale(state),
    isSteamStartup: state => steamSelectors.isSteamStartup(state),
}



// WEBPACK FOOTER //
// ./src/features/LoadingBar/imports.js